import api from '@/services/api'

export const saveAnswer = async (userId, data) => {
    try {
        return api.post(`enps-research-answers/${userId}/send`, data)
    } catch (e) {
        console.error(e)
    }
}

export const saveHumorAnswer = async (data) => {
    try {
        return api.post(`quiz/answer`, data)
    } catch (e) {
        console.error(e)
    }
}
